class CollectionAttributeSidebar {
  constructor(collectionTags) {
    this._collectionTagsGlobal = collectionTags; // Tags for the current collection, defined in the collection-attribute-sidebar.liquid snippet
    this._collectionTags = [];
    this._filterCollectionTags = []; // Tags for the current collection, if fitlers are applied
    this._filterData = {};
    this._priceData = [];
    this._appliedFilters = [];
    this._productsToRemove = [];
    this._currentSortBy = {
      optionValue: "default",
      dataSort: "default",
    };
    this._currentPaginationState = {
      paginationIsVisible: true,
      paginationWrapper: null,
    };
    this._hasFitment = false;
    this._currentFitment = null;
    this._isTier2Selected = false;
    this._tagsContainer = document.getElementById("tags");

    // Debouncing and request cancellation (Issue 4 - Performance)
    this._filterDebounceTimer = null;
    this._filterDebounceDelay = 150; // ms
    this._currentAbortController = null;

    // Cached DOM references (Issue 4 - Performance)
    this._productGrid = document.getElementById("main-collection-product-grid");
    this._collectionContainer = document.getElementById("collection-container");
    this._loadingOverlay = document.querySelector(".loading-overlay--custom");
    this._paginationWrapper = document.querySelector(".pagination-wrapper");
    this._clearAllBtn = document.getElementById("clear-all-filters");
    this._filteredInventoryContainer = document.getElementById("filtered-inventory");
    this._activeFiltersContainer = document.getElementById("active-filters");
    this._emptyMessage = document.getElementById("collection-empty-message");
    this._noProductsMessage = document.getElementById("collection-no-products-message");
    this._appliedFilterTagsContainer = document.getElementById("applied-filter-tags");

    // In-memory caches for GraphQL responses (Issue 4 - Performance)
    // These are session-scoped (clear on page refresh) to avoid stale data
    this._fitmentCache = new Map(); // SKU -> { metafield, tags }
    this._tagCache = new Map(); // cacheKey -> { data, timestamp }
    this._tagCacheTTL = 5 * 60 * 1000; // 5 minutes TTL for tag cache

    this.initData(this._collectionTagsGlobal);
    this.bindEvents();
    this.loadFiltersFromSession();
  }

  // Getters and setters
  get classState() {
    return {
      collectionTags: this._collectionTags,
      filterData: this._filterData,
      priceData: this._priceData,
      appliedFilters: this._appliedFilters,
      currentSortBy: this._currentSortBy,
      hasFitment: this._hasFitment,
      currentFitment: this._currentFitment,
      isTier2Selected: this._isTier2Selected,
    };
  }

  getState() {
    return this.classState;
  }

  openSidebar() {
    document.getElementById("collection-attribute-sidebar").style.width =
      "350px";
  }

  handleAppliedFilters() {
    const filteredInventoryContainer = this._filteredInventoryContainer;
    const productList = this._productGrid;
    const paginationWrapper = this._paginationWrapper;

    // Clear the filtered-inventory container first
    filteredInventoryContainer.innerHTML = "";

    if (this._appliedFilters.length > 0) {
      // Create a <p> element for inventory quantity
      const inventoryQuan = document.createElement("p");
      let visibleProducts = 0;

      // Get visible product count
      if (productList) {
        visibleProducts = productList.querySelectorAll(
          ".product-masonry-item"
        ).length;
      }

      // Check if pagination is available and visible
      if (
        paginationWrapper &&
        this._currentPaginationState.paginationIsVisible
      ) {
        const paginationDiv = document.querySelector(
          ".pagination-page-item.pagination-page-total"
        );
        const totalSpan = Array.from(
          paginationDiv.querySelectorAll("span")
        ).find((span) => span.textContent.includes(" of"));

        if (totalSpan) {
          const totalNumber = totalSpan.textContent.match(/\d+/)?.[0];
          inventoryQuan.textContent = `${totalNumber} items`;
        }
      } else if (visibleProducts > 0) {
        inventoryQuan.textContent = `${visibleProducts} items`;
      } else {
        inventoryQuan.textContent = `No items found`;
      }

      // Append the inventory quantity to the container
      filteredInventoryContainer.appendChild(inventoryQuan);
    }

    // Generate the filter list regardless of filter state
    this.generateFilterList();
  }

  generateFilterList() {
    // Clear the existing filters
    const filterContainer = this._activeFiltersContainer;
    filterContainer.innerHTML = "";

    for (let i = 0; i < this._appliedFilters.length; i++) {
      // Create the outer div
      const div = document.createElement("div");
      div.classList.add("filter-tag");

      // Create the label
      const span = document.createElement("span");
      span.classList.add("filter-label");
      span.textContent = this._appliedFilters[i].replace(/tier\d+: /g, "");

      // Create remove button
      const button = document.createElement("button");
      button.classList.add("remove-filter");
      button.innerHTML = "✕";

      button.addEventListener("click", () => {
        const [filterType, filterValue] = this._appliedFilters[i].split(":");
        this.removeFilter(filterType, filterValue);
        this.saveFiltersToSession();
        this.applyFilters();
        this.handleAppliedFilters();
        //console.log("Removed: ", filterValue)
      });

      // Append the span and button to the div
      div.appendChild(span);
      div.appendChild(button);

      // Append the filter tag div to the filter container
      filterContainer.appendChild(div);
    }
  }

  closeSidebar() {
    document.getElementById("collection-attribute-sidebar").style.width = "0";
  }

  async initData(collectionTagsArg) {
    this.handleAppliedFilters();
    const rawFitmentData = localStorage.getItem("fitmentData");
    let parsedFitmentData = rawFitmentData ? JSON.parse(rawFitmentData) : null;

    const threeDaysInMs = 1000 * 60 * 60 * 24 * 3;
    const lastUpdatedMs = parsedFitmentData?.lastUpdated
    ? Number(parsedFitmentData.lastUpdated)
    : null;
 
    const isExpired =
    lastUpdatedMs &&
    Number.isFinite(lastUpdatedMs) &&
    Date.now() - lastUpdatedMs > threeDaysInMs;

    if (isExpired) {
    localStorage.removeItem("fitmentData");
    parsedFitmentData = null;
    }

    const hasNonEmptyVehicle =
    parsedFitmentData &&
    Object.keys(parsedFitmentData.currentVehicle || {}).length > 0;

    this._hasFitment = Boolean(hasNonEmptyVehicle);
    this._currentFitment = this._hasFitment
    ? parsedFitmentData.currentVehicle
    : null;
    this._collectionTags = collectionTagsArg;
    const tags = this._collectionTags;
    const tagsContainer = this._tagsContainer;

    // Create Category section first
    const categorySection = this.createCollapsibleSection("Category", true);
    const categorySectionContent =
      categorySection.querySelector("#category-content");
    tagsContainer.appendChild(categorySection);

    this.processTags(tags, categorySectionContent, tagsContainer);

  }

  processTags(tags, categorySectionContent, tagsContainer) {
    // Process Tier2 tags for the Category section
    tags
      .filter((tag) => tag.toLowerCase().startsWith("tier2:"))
      .forEach((tag) => {
        const [, filterValue] = tag.split(":");
        this.createFilterElements(
          categorySectionContent,
          "Tier2",
          filterValue,
          "tier2"
        );
      });

    tags
      .filter((tag) => tag.toLowerCase().startsWith("tier3:"))
      .forEach((tag) => {
        const [, filterValue] = tag.split(":");
        this.createFilterElements(
          categorySectionContent,
          "Tier3",
          filterValue,
          "tier3"
        );
      });

    // Process other tags
    tags.forEach((tag) => {
      if (
        tag.includes(":") &&
        !tag.toLowerCase().startsWith("tier2:") &&
        !tag.toLowerCase().startsWith("tier3:") &&
        !tag.toLowerCase().includes("price")
      ) {
        const [filterType, filterValue] = tag.split(":");
        const transformedFilterType = this.toTitleCase(filterType);

        if (!this._filterData[transformedFilterType]) {
          this._filterData[transformedFilterType] = [];
        }

        this._filterData[transformedFilterType].push(filterValue);
      } else if (tag.toLowerCase().includes("price")) {
        const [, filterValue] = tag.split(":");
        this._priceData.push(Number(filterValue));
      }
    });

    // Create facet filter sections
    for (const [filterType, filterValues] of Object.entries(this._filterData)) {
      const filterSection = this.createCollapsibleSection(filterType);
      tagsContainer.appendChild(filterSection);

      const contentDiv = filterSection.querySelector(".filter-content");
      filterValues.sort().forEach((filterValue, index) => {
        this.createFilterElements(contentDiv, filterType, filterValue, index);
      });
    }

    // Sort category section
    const categoryContent = document.getElementById("category-content");
    const categoryContentChildren = Array.from(categoryContent.children);
    categoryContentChildren.sort((a, b) => {
      const aText = a.querySelector("label").innerText;
      const bText = b.querySelector("label").innerText;
      return aText.localeCompare(bText);
    });
    categoryContentChildren.forEach((child) => {
      categoryContent.appendChild(child);
    });
  }

  createFilterElements(container, filterType, filterValue, index) {
    if (filterType === "Tier2") {
      // Handle category-specific logic for tier2 filterType
      return this.createCategoryFilterElements(
        container,
        filterType,
        filterValue,
        index
      );
    }

    const filterValueDiv = document.createElement("div");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = filterValue + index;
    checkbox.name = filterType;
    checkbox.value = filterValue;
    checkbox.classList.add("filter-checkbox", "collection-filters__item");

    // Adding data attributes for filterType and filterValue
    checkbox.setAttribute("data-filter-type", filterType);
    checkbox.setAttribute("data-filter-value", filterValue);

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.innerText = filterValue;
    label.classList.add("filter-checkbox-label");

    filterValueDiv.appendChild(checkbox);
    filterValueDiv.appendChild(label);

    container.appendChild(filterValueDiv);
  }

  createCategoryFilterElements(container, filterType, filterValue, index) {
    // Custom logic for category filters (i.e., tier2 tags)
    const filterValueDiv = document.createElement("div");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = filterValue + index;
    checkbox.name = filterType;
    checkbox.value = filterValue;
    checkbox.classList.add("filter-checkbox", "collection-filters__item");

    // Adding data attributes for the Category section
    checkbox.setAttribute("data-filter-type", filterType);
    checkbox.setAttribute("data-filter-value", filterValue);

    const label = document.createElement("label");
    label.htmlFor = checkbox.id;
    label.innerText = filterValue;
    label.classList.add("filter-checkbox-label");

    filterValueDiv.appendChild(checkbox);
    filterValueDiv.appendChild(label);

    container.appendChild(filterValueDiv);
  }

  createCollapsibleSection(filterType, isCategorySection = false) {
    const sectionDiv = document.createElement("div");
    sectionDiv.className = "filter-section";

    const headerDiv = document.createElement("div");
    headerDiv.className = "filter-header";
    headerDiv.innerText = isCategorySection
      ? "Category"
      : this.toTitleCase(
          filterType.toLowerCase().includes("length")
            ? filterType + " (IN)"
            : filterType
        );

    const contentDiv = document.createElement("div");
    contentDiv.className = "filter-content";

    if (isCategorySection) {
      contentDiv.id = "category-content";
    }

    sectionDiv.appendChild(headerDiv);
    sectionDiv.appendChild(contentDiv);

    headerDiv.addEventListener("click", () => {
      const contentDiv = sectionDiv.querySelector(".filter-content");
      contentDiv.classList.toggle("show");
      headerDiv.classList.toggle("active");
    });

    return sectionDiv;
  }

  async resetAndRebuildFilters(collectionTagsArg) {
    // Step 1: Reset filters
    const tagsContainer = this._tagsContainer;
    this._filterData = {}; // Clear existing filter data
    tagsContainer.innerHTML = ""; // Clear existing filters

    // Step 2: Rebuild filters
    await this.initData(collectionTagsArg);

    // Step 3: Bind facet events
    this.bindCheckboxEvents();
    this.setAppliedFacetFiltersChecked();
  }

  bindEvents() {
    document
      .getElementById("open-sidebar")
      .addEventListener("click", () => this.openSidebar());
    document
      .getElementById("close-sidebar")
      .addEventListener("click", () => this.closeSidebar());
    window.addEventListener("click", (event) => {
      const sidebar = document.getElementById("collection-attribute-sidebar");
      const openButton = document.getElementById("open-sidebar");

      if (!sidebar.contains(event.target) && event.target !== openButton) {
        this.closeSidebar();
      }
    });
    this.bindCheckboxEvents();

    document
      .getElementById("clear-all-filters")
      .addEventListener("click", () => this.clearAllFilters());

     // Event delegation for Load More button
     document.addEventListener("click", async (event) => {
      const target = event.target;
      if (target.matches("[data-load-more]")) {
        event.preventDefault();
        const nextPageUrl = target.getAttribute("data-href");
        if (nextPageUrl) {
          const newProductGrid = await this.getFilteredProducts(nextPageUrl);
          // Append new products rather than replacing existing ones.
          this.renderProductList(newProductGrid, true);
        }
      }
    });
  }

  handleFilterChange(event) {
    const filterType = event.target.name;
    const filterValue = event.target.value;

    if (event.target.checked) {
      this.addFilter(filterType, filterValue);
    } else {
      this.removeFilter(filterType, filterValue);
    }

    if (this._appliedFilters.length > 0) {
      this._clearAllBtn.style.display = "block";
    } else {
      this._clearAllBtn.style.display = "none";
    }
    this.saveFiltersToSession();
    this.applyFilters();
  }

  addFilter(filterType, filterValue) {
    if (filterType.includes("Tier2")) this.handleTier2Selection();

    let currentFilterTag = "";
    const currentTagLowerCase =
      filterType.toLowerCase() + ":" + filterValue.toLowerCase();
    for (let i = 0; i < this._collectionTags.length; i++) {
      if (
        this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
        this.handleizeTag(currentTagLowerCase)
      ) {
        currentFilterTag = this._collectionTags[i];
        break;
      }
    }
    if (!this._appliedFilters.includes(currentFilterTag)) {
      this._appliedFilters.push(currentFilterTag);
    }
  }

  removeFilter(fitlerType, filterValue) {
    let currentFilterTag = "";
    const currentTagLowerCase =
      fitlerType.toLowerCase() + ":" + filterValue.toLowerCase();
    for (let i = 0; i < this._collectionTags.length; i++) {
      if (
        this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
        this.handleizeTag(currentTagLowerCase)
      ) {
        currentFilterTag = this._collectionTags[i];
        break;
      }
    }
    if (this._appliedFilters.includes(currentFilterTag)) {
      const index = this._appliedFilters.indexOf(currentFilterTag);
      this._appliedFilters.splice(index, 1);
    }
  }

  async handleTier2Selection() {
    this._isTier2Selected = true;
  }

  clearAllFilters() {
    this._appliedFilters = [];
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      checkbox.checked = false;
    });
    this._clearAllBtn.style.display = "none";
    this.saveFiltersToSession();
    this.applyFilters();
  }

  /**
   * Debounced filter application - prevents rapid successive API calls
   * when user clicks multiple filters quickly
   */
  applyFilters() {
    // Cancel any pending debounce timer
    if (this._filterDebounceTimer) {
      clearTimeout(this._filterDebounceTimer);
    }

    // Cancel any in-flight request
    if (this._currentAbortController) {
      this._currentAbortController.abort();
    }

    // Debounce the actual filter application
    this._filterDebounceTimer = setTimeout(() => {
      this._applyFiltersInternal();
    }, this._filterDebounceDelay);
  }

  /**
   * Internal filter application - called after debounce delay
   */
  async _applyFiltersInternal() {
    // Create new AbortController for this request
    this._currentAbortController = new AbortController();

    this.toggleLoading(true);

    try {
      const newProductGrid = await this.getFilteredProducts();

      // Check if request was aborted
      if (this._currentAbortController.signal.aborted) {
        return;
      }

      this.renderProductList(newProductGrid);
      this.renderAppliedFilterTags();
      this.handleAppliedFilters();
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error("Error applying filters:", error);
      }
    } finally {
      this.toggleLoading(false);
    }
  }

  async processProductData(collectionHandle) {
    const hasFilters = this._appliedFilters.length > 0 || this._hasFitment;
    const isDefaultSort = this._currentSortBy.optionValue === "default";

    let concatenatedFilters = null;
    if (hasFilters) {
      concatenatedFilters = this._appliedFilters
        .map((filter) => this.handleizeTag(filter))
        .join("+");
    }

    try {
      if (hasFilters && isDefaultSort) {
        const products = await this.fetchProductData(
          collectionHandle,
          concatenatedFilters,
          null
        );

        return sortBy(products, this._currentSortBy);
      } else if (hasFilters && !isDefaultSort) {
        const products = await this.fetchProductData(
          collectionHandle,
          concatenatedFilters,
          "title-ascending"
        );
        return products;
      } else if (!hasFilters) {
        const products = await this.fetchUnfilteredSortedProductData(
          collectionHandle,
          "title-ascending"
        );
        return products;
      } else {
        // Optional fallback case
        console.warn("Unhandled case in processProductData");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async fetchProductData(collectionHandle, concatenatedFilters, sortKey) {
    const url = sortKey
      ? `/collections/${collectionHandle}/${concatenatedFilters}?sort_by=title-ascending`
      : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
          this._hasFitment,
          concatenatedFilters
        )}?sort_by=title-ascending`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Fetch failed", response.status);
        return;
      }
      const data = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;

      const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
      await this.handlePagination(newPaginationWrapper);

      return Array.from(
        tempDiv.querySelector("#main-collection-product-grid").children
      );
    } catch (error) {
      console.error(error);
    }
  }

  async fetchUnfilteredSortedProductData(collectionHandle, sortKey) {
    const url = !this._hasFitment
      ? `/collections/${collectionHandle}?sort_by=${sortKey}`
      : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
          this._hasFitment,
          null
        )}?sort_by=${sortKey}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Fetch failed", response.status);
        return;
      }
      const data = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;

      const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
      await this.handlePagination(newPaginationWrapper);

      return Array.from(
        tempDiv.querySelector("#main-collection-product-grid").children
      );
    } catch (error) {
      console.error(error);
    }
  }

  async addConcatenatedUrlFitmentFilters(hasFitment, concatenatedFilters) {
    const fitment = await JSON.parse(localStorage.getItem("fitmentData"))
      .currentVehicle;

    let handleized;

    // Concatenate the values dynamically
    let modifiedUrl = "";

    if (hasFitment) {
      handleized = Object.keys(fitment).reduce((acc, key) => {
        if (key !== "submodel") {
          acc[key] = fitment[key] ? this.handleizeTag(fitment[key]) : null;
        }
        return acc;
      }, {});

      const fitmentValues = Object.values(handleized).filter(Boolean).join("+");

      modifiedUrl = concatenatedFilters
        ? `${concatenatedFilters}+${fitmentValues}`
        : fitmentValues;
    } else {
      modifiedUrl = concatenatedFilters || "";
    }

    return hasFitment ? modifiedUrl : concatenatedFilters;
  }

  async handlePagination(newPaginationWrapper) {
    // Assign the newPaginationWrapper to state
    this._currentPaginationState.paginationWrapper = newPaginationWrapper;

    // Update visibility state based on whether newPaginationWrapper exists
    this._currentPaginationState.paginationIsVisible =
      Boolean(newPaginationWrapper);
  }

  async getFilteredProducts(nextPageUrl = null) {
    this.toggleLoading(true);
    try {
      let newProductGrid;
      if (nextPageUrl) {
        const response = await fetch(nextPageUrl);
        if (!response.ok) {
          console.error("Fetch failed", response.status);
          return;
        }

        const data = await response.text();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;

        // Update pagination
        const newPaginationWrapper = tempDiv.querySelector(".pagination-wrapper");
        await this.handlePagination(newPaginationWrapper);

        // Extract all product items from the new page
        const fullProductList = Array.from(
          tempDiv.querySelectorAll("#main-collection-product-grid .product-masonry-item")
        );

        // --- Key fix: detect what we already have and slice out the overlap ---
        const currentCount = this._productGrid ? this._productGrid.querySelectorAll(".product-masonry-item").length : 0;
        const newOnly = fullProductList.slice(currentCount);

        // Create a clean wrapper to return only new items
        const newGridFragment = document.createElement("div");
        newOnly.forEach((product) => newGridFragment.appendChild(product.cloneNode(true)));

        newProductGrid = newGridFragment;

        if (this._hasFitment) {
          await this.applyFitmentToProductData(newProductGrid);
        }
      } else {
        // Original behavior: fetch products based on the current state.
        const collectionHandle = window.location.pathname.split("/")[2];
        const sortedProducts = await this.processProductData(collectionHandle);
        const productUl = this._productGrid.cloneNode(false);
        sortedProducts.forEach((product) => {
          productUl.appendChild(product);
        });
        newProductGrid = document.createElement("div");
        newProductGrid.appendChild(productUl);

        if (this._hasFitment) {
          await this.applyFitmentToProductData(newProductGrid);
        }

        this.handleCollectionTagsUpdate();
      }
      this.toggleLoading(false);
      return newProductGrid;
    } catch (error) {
      console.error("Error getting filtered products: ", error);
    }
  }


  renderProductList(productHtml, append = false) {
    const container = this._collectionContainer;
    const productList = this._productGrid;
    const emptyMessage = this._emptyMessage;
    const noProductsMessage = this._noProductsMessage;
    const totalProducts = parseInt(container.dataset.totalProducts, 10);

    // Select the new products from the fetched HTML.
    const newProducts = productHtml.querySelectorAll(".product-masonry-item");

    if (!append) {
      // For an initial load, clear the entire product list.
      productList.innerHTML = "";
    }

    // Append each new product.
    newProducts.forEach((product) => {
      productList.appendChild(product.cloneNode(true));
    });

    // Remove non-fitting products
    if (this._productsToRemove.length > 0) {
      this._productsToRemove.forEach((sku) => {
        this.removeNonFittingProduct(sku);
      });
      this._productsToRemove = [];
    }

    // Handle empty messages / product count updates as before.
    const visibleProducts = productList.querySelectorAll(".product-masonry-item").length;

    if (visibleProducts === 0) {
      productList.style.display = "none";
      if (totalProducts > 0) {
        emptyMessage.style.display = "block";
        noProductsMessage.style.display = "none";
      } else {
        emptyMessage.style.display = "none";
        noProductsMessage.style.display = "block";
      }
    } else {
      productList.style.display = "block";
      emptyMessage.style.display = "none";
      noProductsMessage.style.display = "none";
    }

    // Update pagination content if available.
    const paginationWrapper = this._paginationWrapper;
    if (paginationWrapper) {
      if (visibleProducts > 0 && this._currentPaginationState.paginationIsVisible) {
        paginationWrapper.style.display = "block";
        if (this._currentPaginationState.paginationWrapper) {
          paginationWrapper.innerHTML = this._currentPaginationState.paginationWrapper.innerHTML;
        }
      } else {
        paginationWrapper.style.display = "none";
      }
    }
    // Resize grid items and update product count.
    this.resizeAllGridItems();
    const productCountElement = document.querySelector(".toolbar__product-count");
    if (productCountElement) {
      productCountElement.textContent = `${visibleProducts} products`;
    }
  }

  /**
   * Batched layout resize - prevents layout thrashing by separating reads and writes
   * Issue 4 Performance: Reduces N layout recalculations to 2 (one read pass, one write pass)
   */
  resizeAllGridItems() {
    const grid = document.getElementsByClassName("halo-row--masonry")[0];
    if (!grid) return;

    const allItems = Array.from(document.getElementsByClassName("product-masonry-item"));
    if (allItems.length === 0) return;

    // Get grid properties once (single read)
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"));
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-row-gap"));

    // Read phase: gather all measurements at once (batched reads)
    const measurements = allItems.map(item => {
      const productItem = item.querySelector(".product-item");
      return productItem ? productItem.getBoundingClientRect().height : 0;
    });

    // Write phase: apply all changes in a single animation frame (batched writes)
    requestAnimationFrame(() => {
      allItems.forEach((item, index) => {
        const height = measurements[index];
        if (height > 0) {
          const rowSpan = Math.ceil((height + rowGap) / (rowHeight + rowGap));
          item.style.gridRowEnd = "span " + rowSpan;
        }
      });

      // Show grid after all items are sized
      grid.classList.add("is-show");
    });
  }

  renderAppliedFilterTags() {
    const tagsContainer = this._appliedFilterTagsContainer;
    tagsContainer.innerHTML = ""; // Clear existing tags

    // Iterate through the applied filters
    this._appliedFilters.forEach((filter) => {
      // Strip the filter type and colon from the filter string
      const filterValue = filter.split(":")[1];
      // Create a div element for each tag
      const tagElement = document.createElement("div");
      tagElement.className = "applied-filter-tag";
      tagElement.textContent = filterValue;

      // Create a remove button for the tag
      const removeButton = document.createElement("button");
      removeButton.textContent = "x";
      removeButton.className = "remove-filter-button";

      // Attach the click event to the remove button
      removeButton.addEventListener("click", () => {
        const [filterType, filterValue] = filter.split(":");

        this.removeFilter(filterType, filterValue);

        // Find the corresponding checkbox
        const checkboxSelector = `.filter-checkbox[name='${filterType}'][value='${filterValue}']`;
        const correspondingCheckbox = document.querySelector(checkboxSelector);

        // Uncheck the checkbox
        if (correspondingCheckbox) {
          correspondingCheckbox.checked = false;
        }
        this.saveFiltersToSession();
        this.applyFilters();
      });

      tagElement.appendChild(removeButton);
      tagsContainer.appendChild(tagElement);
    });

    // Show "Clear Filters" link if there are any applied filters
    if (this._appliedFilters.length > 0) {
      this._clearAllBtn.style.display = "block";
    } else {
      this._clearAllBtn.style.display = "none";
    }

    // Hide the entire filter component if there are no available filters to apply
    const filterComponent = document.getElementById(
      "collection-attribute-sidebar"
    );
    const openButton = document.getElementById("open-sidebar");
    const hasAvailableFilters =
      Object.keys(this._filterData).length > 0 || this._priceData.length > 0;
  }

  async handleCollectionTagsUpdate() {
    this.toggleFilterLoading(true);
    const newTags =
      !this._hasFitment && this._appliedFilters.length === 0
        ? await this.getAllCollectionTags()
        : await this.getAllFilteredTags();
    this.updateCollectionTags(newTags);
  }

  async getAllCollectionTags() {
    const collectionHandle = window.location.pathname.split("/").pop();
    const cacheKey = `all-tags-${collectionHandle}`;

    // Check cache first (with TTL)
    const cached = this._tagCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < this._tagCacheTTL) {
      return cached.data;
    }

    try {
      let tagsFlat = [];
      let hasNextPage = true;
      let lastCursor = null;

      while (hasNextPage) {
        let afterCursor = lastCursor ? `, after: "${lastCursor}"` : "";
        let collectionQuery = `
          query {
            collectionByHandle(handle: "${collectionHandle}") {
              products(first: 250${afterCursor}) {
                pageInfo {
                  hasNextPage
                }
                edges {
                  cursor
                  node {
                    tags
                  }
                }
              }
            }
          }`;

        const response = await makeGraphQLRequest(collectionQuery);

        if (!response || !response.data) {
          throw new Error("Invalid response from the server");
        }

        hasNextPage =
          response.data.collectionByHandle.products.pageInfo.hasNextPage;
        const edges = response.data.collectionByHandle.products.edges;

        if (edges.length > 0) {
          lastCursor = edges[edges.length - 1].cursor;

          const tags = edges.map((edge) => edge.node.tags);
          tagsFlat = tagsFlat.concat(tags.flat());
        } else {
          hasNextPage = false;
        }
      }

      // Cache the result
      this._tagCache.set(cacheKey, { data: tagsFlat, timestamp: Date.now() });

      return tagsFlat;
    } catch (error) {
      console.error("Error getting collection tags: ", error);
      return [];
    }
  }
  /**
   * Get all tags for products in the current collection, respecting applied filters and fitment.
   * Uses collection-scoped queries for accurate results within the collection context.
   * Handles pagination for collections with 250+ products.
   * Results are cached with TTL to avoid redundant API calls.
   */
  async getAllFilteredTags() {
    const collectionHandle = window.location.pathname.split("/").pop();

    // Build filters array from applied filters using Shopify's filter syntax
    const filterObjs = this._appliedFilters.map(f =>
      `{tag: "${f.replace(/"/g, '\\"')}"}`
    );
    const filtersArg = filterObjs.length
      ? `, filters: [${filterObjs.join(",")}]`
      : "";

    const hasFitment = this._hasFitment &&
      this._currentFitment &&
      Object.keys(this._currentFitment).length > 0;

    // Build cache key from filter state and fitment
    const fitmentKey = hasFitment ? JSON.stringify(this._currentFitment) : 'none';
    const filtersKey = this._appliedFilters.sort().join('|');
    const cacheKey = `filtered-tags-${collectionHandle}-${filtersKey}-${fitmentKey}`;

    // Check cache first (with TTL)
    const cached = this._tagCache.get(cacheKey);
    if (cached && Date.now() - cached.timestamp < this._tagCacheTTL) {
      return cached.data;
    }

    let allTags = [];
    let hasNextPage = true;
    let cursor = null;

    // Paginate through all products in collection
    while (hasNextPage) {
      const afterArg = cursor ? `, after: "${cursor}"` : "";

      // Use different query structure based on whether fitment checking is needed
      const query = hasFitment
        ? `query {
            collection(handle: "${collectionHandle}") {
              products(first: 250${filtersArg}${afterArg}) {
                pageInfo { hasNextPage }
                edges {
                  cursor
                  node {
                    tags
                    variants(first: 1) {
                      edges {
                        node {
                          metafield(namespace: "pim", key: "fitment_details") {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }`
        : `query {
            collection(handle: "${collectionHandle}") {
              products(first: 250${filtersArg}${afterArg}) {
                pageInfo { hasNextPage }
                edges {
                  cursor
                  node { tags }
                }
              }
            }
          }`;

      const resp = await makeGraphQLRequest(query);

      // Guard against missing data
      if (!resp?.data?.collection?.products) {
        console.warn("getAllFilteredTags: No collection data returned");
        break;
      }

      const { pageInfo, edges } = resp.data.collection.products;
      hasNextPage = pageInfo.hasNextPage;

      if (edges.length > 0) {
        cursor = edges[edges.length - 1].cursor;

        for (const edge of edges) {
          if (hasFitment) {
            // Check fitment match before including tags
            const mf = edge.node.variants?.edges?.[0]?.node?.metafield;
            // Include tags if: no metafield (universal fit) OR metafield matches fitment
            if (!mf || isSubmodelMatch(mf.value, this._currentFitment)) {
              allTags.push(...edge.node.tags);
            }
          } else {
            // No fitment to check, include all tags
            allTags.push(...edge.node.tags);
          }
        }
      } else {
        hasNextPage = false;
      }
    }

    // Dedupe and cache the result
    const uniqueTags = [...new Set(allTags)];
    this._tagCache.set(cacheKey, { data: uniqueTags, timestamp: Date.now() });

    return uniqueTags;
  }

  // buildTagFilterQuery - REMOVED
  // Replaced by inline filter building in getAllFilteredTags() using Shopify's collection filter syntax

  async updateCollectionTags(newTags) {
    try {
      let tags = [];
      newTags.forEach((tag) => {
        if (!tags.includes(tag)) {
          tags.push(tag);
        }
      });
      // Update the collection tags
      this._collectionTags = tags;
      await this.resetAndRebuildFilters(this._collectionTags);
      this.toggleFilterLoading(false);
    } catch (error) {
      console.error("Error updating collection tags: ", error);
    }
  }

  async applyFitmentToProductData(productDataHtml) {
    const currentFitment = this._currentFitment;
    if (!currentFitment || Object.keys(currentFitment).length === 0) {
      return;
    }

    const elements = productDataHtml.querySelectorAll(
      "#main-collection-product-grid li > div"
    );

    if (elements.length === 0) {
      return;
    }

    // Collect all variant SKUs from the product grid
    const variantSkuList = [];
    elements.forEach((element) => {
      const variantObj = parseVariantData(element);
      if (variantObj && variantObj.variantSku) {
        variantSkuList.push(variantObj);
      }
    });

    if (variantSkuList.length === 0) {
      return;
    }

    // Extract just the SKUs for the batched query
    const allSkus = variantSkuList.map(v => v.variantSku);

    // Check which SKUs are already cached (avoid redundant API calls)
    const uncachedSkus = allSkus.filter(sku => !this._fitmentCache.has(sku));

    // Only make GraphQL request if there are uncached SKUs
    if (uncachedSkus.length > 0) {
      const query = generateBatchedProductQuery(uncachedSkus);
      const response = await makeGraphQLRequest(query);

      if (response?.data?.products?.edges) {
        // Cache the new results
        for (const edge of response.data.products.edges) {
          const product = edge.node;
          const variantEdge = product.variants?.edges?.[0];
          if (variantEdge?.node?.sku) {
            this._fitmentCache.set(variantEdge.node.sku, {
              metafield: variantEdge.node.metafield?.value || null,
              tags: product.tags || []
            });
          }
        }
      }
    }

    // Process each product using cached data
    for (const variant of variantSkuList) {
      const productData = this._fitmentCache.get(variant.variantSku);

      if (productData) {
        // Check fitment match
        const productMatched = productData.metafield
          ? isSubmodelMatch(productData.metafield, currentFitment)
          : null;

        // If explicitly doesn't match (false, not null), add to remove list
        if (productMatched === false) {
          this._productsToRemove.push(variant.variantSku);
        }

        // Collect tags if filters are applied
        if (this._appliedFilters.length > 0) {
          productData.tags.forEach((tag) => {
            if (!this._filterCollectionTags.includes(tag)) {
              this._filterCollectionTags.push(tag);
            }
          });
        }
      }
    }
  }

  // handleProductMetafieldAndTags - REMOVED
  // Logic now integrated into applyFitmentToProductData() batched approach

  removeNonFittingProduct(sku) {
    const elements = document.querySelectorAll(
      "#main-collection-product-grid li > div"
    );

    elements.forEach((element) => {
      const variantObjSku = parseVariantData(element).variantSku;
      if (variantObjSku === sku) {
        element.parentElement.remove();
      }
    });
    return;
  }

  toggleLoading(show) {
    const loadingOverlay = this._loadingOverlay;
    if (loadingOverlay) {
      loadingOverlay.style.display = show ? "block" : "none";
    }
  }

  toggleFilterLoading(show) {
    const loadingDiv = `<div id="js-loading-div" class="loading-overlay loading-overlay--custom" style="display: block;">
                    <div class="loading-overlay__spinner" aria-label="{{ 'general.button_load_more.loading' | t }}"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
                </div>`;
    const tagsDiv = document.getElementById("tags");
    if (show) {
      tagsDiv.insertAdjacentHTML("afterbegin", loadingDiv);
    }
  }

  toTitleCase(str) {
    return str
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // Insert space before each capital letter
      .replace(/(\b[a-z](?!\s))/g, (x) => x.toUpperCase()); // Capitalize the first letter of each word
  }

  handleizeTag(input) {
    return input
      .toLowerCase() // Convert to lowercase
      .replace(/:/g, "-") // Replace colons with hyphens
      .replace(/\./g, "-") // Replace periods with hyphens
      .replace(/[^a-z0-9-\s]/g, "") // Remove characters that are not alphanumeric, spaces, or hyphens
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
      .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
  }

  setLoadingState() {
    this._sidebar.classList.add("loading");
  }

  saveFiltersToSession() {
    const state = {
      selectedPriceRange: this._selectedPriceRange,
      appliedFilters: this._appliedFilters,
      currentSortBy: this._currentSortBy.optionValue,
    };
    sessionStorage.setItem(
      `fitlers-${window.location.pathname.split("/")[2]}`,
      JSON.stringify(state)
    );
  }

  loadFiltersFromSession() {
    const savedState = sessionStorage.getItem(
      `fitlers-${window.location.pathname.split("/")[2]}`
    );

    if (savedState) {
      const state = JSON.parse(savedState);
      this._selectedPriceRange = state.selectedPriceRange || { min: 0, max: 0 };
      this._appliedFilters = state.appliedFilters || [];
      this._currentSortBy.optionValue =
        state.currentSortBy.optionValue || "default";

      // Restore checkboxes based on the applied filters
      this.setAppliedFacetFiltersChecked();

      this.applyFilters();

      // Show/Hide clear all filters button based on the applied filters
      if (this._appliedFilters.length > 0) {
        this._clearAllBtn.style.display = "block";
      } else {
        this._clearAllBtn.style.display = "none";
      }
    } else if (!savedState) {
      this.saveFiltersToSession();
      this.applyFilters();
    }
  }

  setAppliedFacetFiltersChecked() {
    this._appliedFilters.forEach((filterTag) => {
      const [filterType, filterValue] = filterTag.split(":");
      const checkboxSelector = `.filter-checkbox[name='${this.toTitleCase(
        filterType
      )}'][value='${filterValue}']`;
      const checkboxElement = document.querySelector(checkboxSelector);
      if (checkboxElement) {
        checkboxElement.checked = true;
      }
    });
  }

  bindCheckboxEvents() {
    document.querySelectorAll(".filter-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", (event) =>
        this.handleFilterChange(event)
      );
    });
  }
}

const collectionAttributeSidebar = new CollectionAttributeSidebar(
  collectionTags
);

// Helper functions
function sortBy(products, currentSortBy) {
  switch (currentSortBy.optionValue) {
    case "low-to-high":
      return products.sort((a, b) => {
        const priceA = parseFloat(
          a
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        const priceB = parseFloat(
          b
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        return priceA - priceB;
      });
    case "high-to-low":
      return products.sort((a, b) => {
        const priceA = parseFloat(
          a
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        const priceB = parseFloat(
          b
            .querySelector(".price-item--regular")
            .textContent.replace(/[^0-9.]/g, "")
        );
        return priceB - priceA;
      });
    case "alpha-asc":
      return products.sort((a, b) => {
        const titleA = a.querySelector(".card-title").textContent.trim();
        const titleB = b.querySelector(".card-title").textContent.trim();
        return titleA.localeCompare(titleB);
      });
    case "alpha-desc":
      return products.sort((a, b) => {
        const titleA = a.querySelector(".card-title").textContent.trim();
        const titleB = b.querySelector(".card-title").textContent.trim();
        return titleB.localeCompare(titleA);
      });
    default:
      return products;
  }
}

function parseVariantData(element) {
  const jsonData = element.getAttribute("data-json-product");
  const decodedStr = decodeURIComponent(jsonData);
  const parsedObj = JSON.parse(decodedStr);
  return {
    productTitle: parsedObj.variants[0].name,
    variantSku: parsedObj.variants[0].sku,
  };
}

function generateProductQuery(variantSku) {
  return `query {
            products(first:1, query: "${variantSku}") {
              edges {
                node {
                  title
                  tags
                  variants(first:1) {
                    edges {
                      node {
                        metafield(namespace:"pim", key:"fitment_details") {
                          value
                          type
                        }
                      }
                    }
                  }
                }
              }
            }
          }`;
}

/**
 * Generates a batched GraphQL query for multiple SKUs
 * This eliminates the N+1 request pattern by fetching all products in one request
 * @param {string[]} skus - Array of variant SKUs to query
 * @returns {string} GraphQL query string
 */
function generateBatchedProductQuery(skus) {
  // Build OR query for all SKUs: "sku1 OR sku2 OR sku3"
  const skuQuery = skus.map(sku => `"${sku}"`).join(' OR ');

  return `query {
    products(first: 250, query: ${JSON.stringify(skuQuery)}) {
      edges {
        node {
          title
          tags
          variants(first: 1) {
            edges {
              node {
                sku
                metafield(namespace: "pim", key: "fitment_details") {
                  value
                  type
                }
              }
            }
          }
        }
      }
    }
  }`;
}

/**
 * Makes a GraphQL request to the Shopify Storefront API
 * @param {string} query - GraphQL query string
 * @returns {Promise<Object>} Response data or error object
 */
async function makeGraphQLRequest(query) {
  try {
    const response = await fetch(
      "/api/2025-01/graphql.json",  // Use relative URL for flexibility
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "488355664613a3f4519a11d10371f3e8",
        },
        body: JSON.stringify({ query }),
      }
    );

    // Handle HTTP errors
    if (!response.ok) {
      console.error(`GraphQL request failed: ${response.status} ${response.statusText}`);
      return { data: null, errors: [{ message: `HTTP ${response.status}` }] };
    }

    const json = await response.json();

    // Check for GraphQL-level errors
    if (json.errors && json.errors.length > 0) {
      console.error("GraphQL errors:", json.errors);
    }

    return json;
  } catch (error) {
    // Handle network errors, JSON parse errors, etc.
    console.error("GraphQL request error:", error);
    return { data: null, errors: [{ message: error.message }] };
  }
}

function isSubmodelMatch(fitmentStrings, fitmentSelection) {

  const { year, make, model, submodel, drive_type, fuel_type } =
    fitmentSelection;

  function stringToObject(fitmentStrings) {
    return fitmentStrings.split(";").map((str) => {
      const [year, make, model, sub_model, drive_type, fuel_type] =
        str.split("|");
      return { year, make, model, sub_model, drive_type, fuel_type };
    });
  }

  function isMatch(fitmentValue, inputValue, wildcard = "*") {
    return (
      inputValue &&
      fitmentValue &&
      (fitmentValue.toLowerCase() === inputValue.toLowerCase() ||
        fitmentValue.toLowerCase() === wildcard)
    );
  }

  const fitmentStringArray = stringToObject(fitmentStrings);
  let isSubModelMatch = false;

  for (const fitment of fitmentStringArray) {

    const yearMatch = fitment.year === year;
    const makeMatch = isMatch(fitment.make, make);
    const modelMatch = isMatch(fitment.model, model);
    const driveTypeMatch = isMatch(fitment.drive_type, drive_type);
    const fuelTypeMatch = isMatch(fitment.fuel_type, fuel_type);
    const submodelMatch = isMatch(fitment.sub_model, submodel);

    // Check if all fields match (considering 'X' as wildcard for submodel)
    if (
      yearMatch &&
      makeMatch &&
      modelMatch &&
      (driveTypeMatch || driveTypeMatch === undefined) &&
      (fuelTypeMatch || fuelTypeMatch === undefined) &&
      (submodelMatch || submodelMatch === undefined)
    ) {
      isSubModelMatch = true;
      break;
    }
  }

  return isSubModelMatch;
}
